import { useOutletContext } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import { useSocketState } from '../../helpers/useSocket';

function SettingsDashboard() {
    const { socket, config } = useOutletContext()
    //const [config, setConfig] = useState({});

    const [themeOptions, setThemeOptions] = useState([])
    const [match] = useSocketState('Match');

    function updateTheme(data) {
        socket.emit("updateTheme", { ...config, ...data })
    }

    function toggleIgnorePlayerNames() {
        socket.emit('modifyMatch', { ignorePlayerNames: !match.ignorePlayerNames });
    }

    useEffect(() => {
        socket.emit('registerSettings')

        const host = process.env.NODE_ENV === 'production' ? window.location.host : `${window.location.hostname}:3001`

        fetch(`${window.location.protocol}//${host}/api/themes`)
            .then(response => response.json())
            .then(data => {
                setThemeOptions(data)
            })
    }, [])

    return (
        <div>
            <h1>Match Settings</h1>
              <label className="inline-flex items-center cursor-pointer">
                <span className="ms-3 text-sm font-medium text-gray-900">Ignore Player Names</span>
                <input type="checkbox" checked={match?.ignorePlayerNames} className="sr-only peer" onChange={toggleIgnorePlayerNames} />
                <div className="relative w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600 dark:peer-checked:bg-blue-600"></div>
              </label>
            <h1>Themes</h1>
            <select value={config.cssTheme} onChange={(e) => updateTheme({ cssTheme: e.target.value })} id="theme" name="theme">
                {themeOptions.map(theme => <option value={theme}>{theme}</option>)}
            </select>
        </div>
    )
}

export default SettingsDashboard;